$.fn.coverSizer = function(options) {
    var settings = $.extend({
        selector: '> *'
    }, options);

    return this.each(function () {
        var $container = $(this),
            $items = $container.find(settings.selector).each(function () {
                var $this = $(this),
                    width = $this.width(),
                    loaded = width > 0;

                $this.data('coverSizer', {
                    ratio: loaded ? width / $this.height() : null
                });
                $this.on('load', resize);
            });

        function resize() {
            var cw = $container.outerWidth(),
                ch = $container.outerHeight(),
                cr = cw / ch;

            $items.each(function () {
                var $item = $(this),
                    ir = $item.data('coverSizer').ratio,
                    dest = {};

                if (!ir) {
                    var width = $item.width(),
                        height = $item.height();

                    if (width > 0 && height > 0) {
                        $item.data('coverSizer').ratio = ir = width / height;
                    } else {
                        return;
                    }
                }

                if (ir > cr) {
                    dest.width = Math.ceil(ch * ir);
                    dest.height = ch;
                    dest.left = (cw - dest.width) / 2;
                    dest.top = 0;
                } else {
                    dest.width = cw;
                    dest.height = Math.ceil(cw / ir);
                    dest.left = 0;
                    dest.top = (ch - dest.height) / 2;
                }

                $item.css(dest);
            });
        }

        $(resize);
        $container.find('img, video').on('load', resize);
        var $slick = $container.closest('.slick-slider');
        if($slick.length) {
            $slick.on('setPosition', resize);
        } else {
            $(window).on('resize', resize);
        }
        $container.data('coverSizer', {
            resize: resize
        });
    });
};
